import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "../../utils/appToast";
import { v4 as uuidv4 } from 'uuid'; // Importing the UUID function
// Example icons: update these imports if needed
import arrowForward2 from "../../Images/arrow_forward-2.svg";
import ChatHistory from "./ChatHistory.jsx";
import Cookies from "js-cookie";
import { getFreshAccessToken } from "../chat/api";
import api from "../chat/api";
// Your custom CSS
import "../AI_Copilot/PromptChat.css";
import ThinkingIndicator from "../../components/Thinking-Animation.jsx";
const PromptChat = ({
  documentKey = "",
  documentUrl = "",
  documentType = "",
  documentId = null,
  selectedDocumentName = "",
  finalResponse = "",
  isChatHistoryOpen,
  generatedQuestions = [],
  chatId,
  initialMessages = [],    // The array of message objects passed from AIcopilot
  onMessagesUpdated = () => { },
  isMenuOpen,
  /** The text from parent you want automatically sent as a user message on mount **/
  chatInput,
  onNewChat,
  action,
  SummarizeDocKey,
  SummarizeDocUrl,
  SummarizeDocType,
  isNewSession,
  enrichedPrompt,
  selectedDocs,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

const activeWsRef = useRef(null);

  const chatContainerRef = useRef(null);
  const textareaRef = useRef(null);
const [hasSentMessage, setHasSentMessage] = useState(false);

  // =============== STATE ===============

  // -- (A) Restore chatHistory from localStorage, or start with []
  const [chatHistory, setChatHistory] = useState([]);
  // map them into your local message shape:
  useEffect(() => {
    if (Array.isArray(initialMessages) && initialMessages.length > 0) {
      const mapped = initialMessages.map((msg) => ({
        id: msg.message_id,
        sender: msg.is_client ? "user" : "bot",
        text: msg.message,
        run_id: msg.run_id,
        final: true,
      }));
      setChatHistory(mapped);
    } else {
      setChatHistory([]);
    }
  }, []); // Run only once on mount


  /// states to track selection of object and values...
  // 1) State for dynamic dropdown
  const [showObjects, setShowObjects] = useState(false);
  const [showValues, setShowValues] = useState(false);
  const [filteredObjects, setFilteredObjects] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [spreadsheets, setSpreadsheets] = useState([]);

  const [invoices, setInvoices] = useState([]);
  const [showAtDropdown, setShowAtDropdown] = useState(false);
  const [filteredAtOptions, setFilteredAtOptions] = useState([]);
  const [PromptChatInput, setPromptChatInput] = useState("");
 const [selectedDoc, setSelectedDoc] = useState(null);
useEffect(() => {
  setSelectedDoc(selectedDocs);
}, [selectedDocs]);



  const [token, setToken] = useState(null);


  // 2) Object-to-values mapping
  const objectOptions = useMemo(() => ({
    Documents: documents.map(doc => ({
      id: doc.id,
      key: doc.key || doc.id,
      name: doc.name,
      url: doc.url,
      type: "document"
    })),
    Contracts: contracts.map(contract => ({
      key: contract.key || contract.id,
      id: contract.id,
      name: contract.name,
      url: contract.url,
      type: "contract"
    })),
    Invoices: invoices.map(invoice => ({
      key: invoice.key || invoice.id,
      id: invoice.id,
      name: invoice.name,
      url: invoice.url,
      type: "invoice"
    })),
    Spreadsheets: documents.filter(doc => doc.name.endsWith(".xlsx") || doc.name.endsWith(".csv"))
      .map(doc => ({
        key: doc.key || doc.id,
        id: doc.id,
        name: doc.name,
        url: doc.url,
        type: "spreadsheet"
      })),

  }), [documents, contracts, invoices, documents]); // Ensure it updates when API data changes

  useEffect(() => {
    if (showObjects) {
      // Once objectOptions updates, update the dropdown items.
      setFilteredObjects(Object.keys(objectOptions));
    }
  }, [objectOptions, showObjects]);


  const objectIcons = {
    Documents: <img src="/ai-object-document-icon.svg" alt="Document Icon" />,
    Contracts: <img src="/ai-object-contract-icon.svg" alt="contracts Icon" />,
    Invoices: <img src="/ai-object-invoice-icon.svg" alt="Invoice Icon" />,
    Spreadsheets: <img src="/ai-object-spread-icon.svg" alt="spreadsheet Icon" />
  };

  const fetchAllDocuments = async () => {
   

    

    const url = `api/v1/copilot/all-docs/`;

    try {
      const response = await api.get(url, {
        
      });


      const { contracts = [], invoices = [], documents = [], spreadsheet = [] } =
        response.data.all_documents || {};

   

      
      setContracts(contracts.map((doc) => ({ key: doc.key,
        id: doc.key, name: doc.name, url: doc.url, type: "contract" })));
      setInvoices(invoices.map((doc) => ({ key: doc.key,
        id: doc.key, name: doc.name, url: doc.url, type: "invoice" })));
      setDocuments(documents.map((doc) => ({ key: doc.key,
        id: doc.key, name: doc.name, url: doc.url, type: "document" })));
      setSpreadsheets(spreadsheet.map((doc) => ({ id: doc.id, name: doc.name, url: doc.url, type: "spreadsheet" })));

    } catch (error) {
      console.error("❌ Error fetching documents:", error);
    }
  };

  const handleAtSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
const spreadsheetDocs = spreadsheets;

    const allDocs = [
      ...documents,
      ...contracts,
      ...invoices,
        ...spreadsheetDocs,

    ].map(doc => ({
      ...doc,
      display: `${doc.name} (${doc.type})`, // Adds document type as context
      id: doc.id || doc.key || uuidv4(),
    }));

    const filtered = allDocs.filter(doc =>
      doc.name.toLowerCase().includes(searchValue)
    );

    setFilteredAtOptions(filtered);
  };

  const handleValuesSearch = (e) => {
    const query = e.target.value.toLowerCase();
    // Determine the full list based on the selected object.
    let fullList = [];
    if (selectedObject === "Documents") {
      fullList = documents;
    } else if (selectedObject === "Contracts") {
      fullList = contracts;
    } else if (selectedObject === "Invoices") {
      fullList = invoices;
   } else if (selectedObject === "Spreadsheets") {
    fullList = spreadsheets.map(doc => ({ ...doc, display: doc.name }));
}

    if (query.trim() === "") {
      // If search query is empty, reset to the full list.
      setFilteredValues(fullList);
    } else {
      // Filter the full list based on the query.
      const filtered = fullList.filter((item) =>
        item.name.toLowerCase().includes(query)
      );
      setFilteredValues(filtered);
    }
  };

  const handlePromptChatChange = (e) => {
    const value = e.target.value;
const spreadsheetDocs = spreadsheets;

    setPromptChatInput(value);  
    setClientMessage(value);

    // When input is empty, clear dropdowns and the selected object.
    if (value.trim() === "") {
      setShowAtDropdown(false);
      setSelectedObject(null); // Clear selected object so that all documents appear later.
    }

    // Trigger fetch when user types "/" (forward slash) and show top-level objects dropdown.
    if (value.endsWith("/")) {
      fetchAllDocuments(); // Call API only when "/" is typed.
      setShowObjects(true);
      setFilteredObjects(Object.keys(objectOptions)); // Show top-level objects.
    } else {
      setShowObjects(false);
    }

    // Trigger "@" dropdown when value ends with "@".
    if (value.endsWith("@")) {
      fetchAllDocuments();
      let options = [];
      if (selectedObject) {
        // Show values for the selected object only.
        if (selectedObject === "Contracts") {
          options = contracts.map(doc => ({ ...doc, display: doc.name }));
        } else if (selectedObject === "Invoices") {
          options = invoices.map(doc => ({ ...doc, display: doc.name }));
        } else if (selectedObject === "Spreadsheets") {
  options = spreadsheets.map(doc => ({ ...doc, display: doc.name }));
}

      } else {
        // Combine all document types
        options = [
          ...documents,
          ...contracts,
          ...invoices,
          ...spreadsheetDocs,
        ].map(doc => ({ ...doc, display: `${doc.name}` }));
      }
      setFilteredAtOptions(options);
      setShowAtDropdown(true);
    } else {
      // Hide the "@" dropdown if the user types further.
      setShowAtDropdown(false);
    }
  };



  const getSingular = (obj) => {
    if (obj === "Contracts") return "Contract";
    if (obj === "Invoices") return "Invoice";
    if (obj === "Spreadsheets") return "Spreadsheet";
    return obj;
  };


  const handleObjectSelection = (obj) => {
    // Remove the trailing "/" from the input and append the object name with " : "
    setPromptChatInput((prev) => prev.slice(0, -1) + obj + " : ");
    setShowObjects(false);
    setSelectedObject(obj);

    setTimeout(() => {
      let values = [];
      if (obj === "Documents") {
        values = [...documents];
      } else if (obj === "Contracts") {
        values = [...contracts];
      } else if (obj === "Invoices") {
        values = [...invoices];
      }else if (obj === "Spreadsheets") {
values = spreadsheets;

      }
      setFilteredValues(values);
      setShowValues(true);
    }, 100);
  };

const handleValueSelection = (val) => {
  if (typeof val === "object") {
    setSelectedDoc(val);
    setPromptChatInput(""); // ✅ clear input, don't show doc name
    setClientMessage("");   // ✅ also clear client message
  }
  setShowValues(false);
  setSelectedObject(null);
};


const handleAtSelection = (doc) => {
  setSelectedDoc(doc);
  setPromptChatInput("");   // ✅ clear input
  setClientMessage("");     // ✅ clear client message
  setShowAtDropdown(false);
};


  
  const handleStopStreaming = () => {
  if (activeWsRef.current) {
    activeWsRef.current.close();
    activeWsRef.current = null;
  }
  setIsLoadingResponse(false);
};

  



  const dropdownValuesRef = useRef(null);

  useEffect(() => {
    // Hide dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownValuesRef.current && !dropdownValuesRef.current.contains(event.target)) {
        setShowValues(false);
      }
    };

    // Hide dropdown when Backspace is pressed
    const handleKeyDown = (event) => {
      if (event.key === 'Backspace') {
        setShowValues(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const executeSummarize = () => {
    if (!isNewSession) return;

    sentRef.current += 1;

    // if (sentRef.current ) return;
    // If the action is specifically "summarize"
    if (sentRef.current === 1 && action === "summarize") {
      sentRef.current = true;
      handleSummarize();
    }
  };

  const executeSendPrompt = () => {
    if (!isNewSession) return;

    sentRef.current += 1;

    if ((sentRef.current === 1 && chatInput?.trim())) {
const enrichedMessage = selectedDoc
  ? `${chatInput.trim()} : ${selectedDoc.type.charAt(0).toUpperCase() + selectedDoc.type.slice(1)} : ${selectedDoc.name.replace(/\.pdf$/i, "")}`
  : chatInput.trim();

handleSendPrompt(enrichedMessage);
    }
  }

  /// fetching chat history for reload
  const handleChatItemClick = async (chatId) => {
      const token = await getFreshAccessToken();
    const url = `${process.env.REACT_APP_API_URL}api/v1/copilot/get-chat-sessions/${chatId}/`;
    try {
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!response.ok) {
  const errorText = await response.text(); // Read the raw response
  console.error(`Failed to fetch chat session: ${response.status}`);
  console.error("Server response:", errorText); // This will show HTML if it's a 404 or error page
  return;
}
const mappedChatHistory = data.chat_history.map((msg) => ({
  id: msg.bot_message_id || msg.django_message_id, // use bot ID as primary identifier
  sender: msg.is_client ? "user" : "bot",
  text: msg.message,
  run_id: msg.run_id,
  bot_message_id: msg.bot_message_id,  // include this explicitly
  final: true,
}));





      // Update state with the mapped chat history
      setChatHistory(mappedChatHistory);


    } catch (error) {
      console.error("Error fetching chat session:", error);
    }
  };

useEffect(() => {
  if (!isNewSession) return;

  if (action === "summarize") {
    executeSummarize();
  } else if (chatInput?.trim()) {
    if (selectedDoc) {
      executeSendPrompt();
    } else {
       executeSendPrompt();
      console.warn("🟡 selectedDoc not ready yet. Delaying prompt send...");
    }
  } else if (chatId) {
    handleChatItemClick(chatId);
  }
}, [chatId, action, chatInput, isNewSession, selectedDoc]); // 👈 added selectedDoc







 


  
  const [generatedPromptQuestions, setGeneratedPromptQuestions] = useState([]);
 
  const [clientMessage, setClientMessage] = useState();
 
  const [isLoadingResponse, setIsLoadingResponse] = useState(false);
  const [typedDummyMessages, setTypedDummyMessages] = useState([]);
  const [thumbsUpClicked, setThumbsUpClicked] = useState({});
  const [thumbsDownClicked, setThumbsDownClicked] = useState({});
  const [copiedMessageId, setCopiedMessageId] = useState(null);
  const [showThumbsDownPopup, setShowThumbsDownPopup] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [messageIdToFeedback, setMessageIdToFeedback] = useState(null);
  const [feedbackId, setFeedbackId] = useState("");
  const [selectedFeedbackType, setSelectedFeedbackType] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({
    factuallyIncorrect: false,
    refused: false,
    notFollowingInstructions: false,
  });

  // Redux or other selectors
  const error = useSelector((state) => state.pdfChat?.error);


  // If parent used react-router state to pass data
  const { pdfKey: dynamicPdfKey, pdfUrl: dynamicPdfUrl, docType } = location.state || {};

  // internal key for doc
  const [pdfKey, setPdfKey] = useState(dynamicPdfKey || "");
  const [pdfUrl, setPdfUrl] = useState("");

  const [clickedIndex, setClickedIndex] = useState(null);

  
  useEffect(() => {
    if (dynamicPdfUrl) {
      setPdfUrl(dynamicPdfUrl);
    }
  }, [dynamicPdfUrl]);


  const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);
  const handleScroll = () => {
    if (!chatContainerRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
    // If user is within 50px of the bottom, keep auto-scroll on; otherwise disable it
    const isNearBottom = scrollHeight - (scrollTop + clientHeight) < 50;
    setAutoScrollEnabled(isNearBottom);
  };

  useEffect(() => {
    if (!chatContainerRef.current) return;
    const container = chatContainerRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (autoScrollEnabled && chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [chatHistory, autoScrollEnabled]);



  // If parent passes new generatedQuestions, store them
  const streamDummyMessages = useCallback((questions) => {
    const maxToShow = 2;
    const limited = questions.slice(0, maxToShow);
    setTypedDummyMessages(new Array(limited.length).fill(""));

    limited.forEach((question, idx) => {
      let charIndex = 0;
      const interval = setInterval(() => {
        setTypedDummyMessages((prev) => {
          const updated = [...prev];
          updated[idx] = question.slice(0, charIndex + 1);
          return updated;
        });
        charIndex++;
        if (charIndex >= question.length) clearInterval(interval);
      }, 30);
    });
  }, []);

  useEffect(() => {
    if (Array.isArray(generatedQuestions) && generatedQuestions.length > 0) {
      streamDummyMessages(generatedQuestions);
      // Also store them in state so they remain after reload
      setGeneratedPromptQuestions(generatedQuestions);
    }
  }, [generatedQuestions, streamDummyMessages]);

  useEffect(() => {
    if (generatedPromptQuestions.length > 0) {
      streamDummyMessages(generatedPromptQuestions);
    }
  }, [generatedPromptQuestions, streamDummyMessages]);


  const hasTriggered = useRef(false);
  const sentRef = useRef(0);




  // Reset clickedIndex when new questions are generated
  useEffect(() => {
    setClickedIndex(null);
  }, [generatedPromptQuestions]);

  // =============== NEW CHAT (OPTIONAL) ===============
  const [newChatId, setNewChatId] = useState(null);

  
  const handleSendPrompt = async (promptValue) => {
    const token = await getFreshAccessToken();

    const generateUniqueId = () =>
      `${Date.now()}-${Math.floor(Math.random() * 10000)}`;

    // 1) Add user message
    const userMsgId = generateUniqueId();
    const cleanedDocumentName = Array.isArray(selectedDoc)
      ? selectedDoc.map(doc => doc.name.replace(/\.pdf$/i, "")).join(", ")
      : selectedDoc
        ? selectedDoc.name.replace(/\.pdf$/i, "")
        : "";
    const userMessage = {
      id: userMsgId,
      sender: "user",
  text: promptValue,

      final: true,
    };
   

    // 2) Placeholder bot message
    const botMsgId = generateUniqueId();
    const botPlaceholder = {
      id: botMsgId,
      sender: "bot",
      text: "",
      final: false,
    };
    setChatHistory((prev) => [...prev, userMessage, botPlaceholder]);
 

    let finalReceived = false;

    setIsLoadingResponse(true);
    setGeneratedPromptQuestions([]);
    setAutoScrollEnabled(true);

    const documentKeys = Array.isArray(selectedDocs)
  ? selectedDocs.map(doc => doc?.key || doc?.id).filter(Boolean)
  : selectedDocs?.key || selectedDocs?.id
    ? [selectedDocs.key || selectedDocs.id]
    : [];

  

    let wsUrl;
    let payload;
    
    if (documentKeys.length > 0) {
      wsUrl = `${process.env.REACT_APP_WS_URL}/ws/prompt-library-answer/${chatId}/?token=${token}`;
      payload = { prompt: promptValue, document_keys: documentKeys };
    } else {
      wsUrl = `${process.env.REACT_APP_WS_URL}/ws/qdrant-copilot-chat/${chatId}/?token=${token}`;
      payload = { client_message: promptValue };
    }
    

    try {
      const ws = new WebSocket(wsUrl);
      activeWsRef.current = ws;
      ws.onopen = () => {
        ws.send(JSON.stringify(payload));
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          // Append streaming messages from the API using the "message" field.
          if (data.type === "progress" && data.message) {
            setChatHistory((prev) =>
              prev.map((msg) =>
                msg.id === botMsgId && !msg.final
                  ? { ...msg, text: msg.text + data.message }
                  : msg
              )
            );
          }

          // Handle final message
          if (data.type === "final") {
            finalReceived = true;
            const finalMessage = data.message || "";
              const backendMessageId = data?.data?.bot_message_id;

            setChatHistory((prev) =>
              prev.map((msg) =>
                msg.id === botMsgId && !msg.final
                  ? { ...msg, text: msg.text + finalMessage, final: true ,id: backendMessageId || msg.id,}
                  : msg
              )
            );
       

            setIsLoadingResponse(false);

            if (data.data && data.data.run_id) {
              const runId = data.data.run_id;
              setFeedbackId(runId);
           
            }

            // If we have generated questions
            if (data.data && data.data.generated_questions) {
              const questionsArray = data.data.generated_questions
                .split(";")
                .map((q) => q.trim())
                .filter(Boolean)
                .slice(0, 2);
              setGeneratedPromptQuestions(questionsArray);
            }

            ws.close();
          }
        } catch (err) {
          console.error("Error parsing WS data:", err);
        }
      };

      ws.onerror = (err) => {
        console.error("WebSocket error:", err);
        setIsLoadingResponse(false);

        if (!finalReceived) {
          setChatHistory((prev) =>
            prev.map((msg) => {
              if (msg.id === botMsgId && !msg.final) {
                return {
                  ...msg,
                  text:
                    "I'm sorry, I'm having trouble contacting the server right now. Please try again later.",
                  final: true,
                };
              }
              return msg;
            })
          );
        }
      };

      ws.onclose = () => {
        setIsLoadingResponse(false);

        if (!finalReceived) {
          setChatHistory((prev) =>
            prev.map((msg) => {
              if (msg.id === botMsgId && !msg.final) {
                return {
                  ...msg,
                  text:
                    "",
                  final: true,
                };
              }
              return msg;
            })
          );
        }
      };
    } catch (error) {
      console.error("WebSocket init error:", error);
      toast.error("Failed to connect to WebSocket. Please try again.");
      setIsLoadingResponse(false);

      setChatHistory((prev) =>
        prev.map((msg) => {
          if (msg.id === botMsgId && !msg.final) {
            return {
              ...msg,
              text:
                "I'm sorry, I'm having trouble connecting at the moment. Please try again later.",
              final: true,
            };
          }
          return msg;
        })
      );
    }
  };



  
  useEffect(() => {
  }, [feedbackId]);

  const handleSummarize = async () => {

   
    const generateUniqueId = () =>
      `${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    const botMsgId = generateUniqueId();
    const botPlaceholder = {
      id: botMsgId,
      sender: "bot",
      text: "",
      final: false,
    };
    setChatHistory((prev) => [...prev, botPlaceholder]);

    let finalReceived = false;

    setIsLoadingResponse(true);
    setGeneratedPromptQuestions([]);
    setAutoScrollEnabled(true);
    let token = await getFreshAccessToken();
    // Summarize WS URL & payload
    const wsUrl = `wss://stagingbackend.docusensa.com/ws/pdf-summary-and-chats/${SummarizeDocKey}/?token=${token}`;
    const payload = {
      pdfKey: SummarizeDocKey,
      client_message: "summarize the document",
    };

    try {
      const ws = new WebSocket(wsUrl);

      ws.onopen = () => {
        ws.send(JSON.stringify(payload));
      };

      ws.onmessage = (event) => {
        try {
          // Some summary endpoints send data prefixed with "data:"
          const rawData = event.data.startsWith("data:")
            ? event.data.slice(5).trim()
            : event.data;
          const data = JSON.parse(rawData);

          if (data.type === "progress" && data.message) {
            setChatHistory((prev) =>
              prev.map((msg) =>
                msg.id === botMsgId && !msg.final
                  ? { ...msg, text: msg.text + data.message }
                  : msg
              )
            );
          }

          if (data.type === "final" || data.pdf_details) {
            finalReceived = true;
            const finalChunk = data.message || "";
            setChatHistory((prev) =>
              prev.map((msg) => {
                if (msg.id === botMsgId && !msg.final) {
                  return { ...msg, text: msg.text + finalChunk, final: true };
                }
                return msg;
              })
            );
            setIsLoadingResponse(false);

            if (data.pdf_details && data.pdf_details.run_id) {
              const runId = data.pdf_details.run_id;
              setFeedbackId(runId);
             
            }

            // If we have generated questions
            if (data.pdf_details && data.pdf_details.example_questions) {
              const questionsArray = data.pdf_details.example_questions
                .split(";")
                .map((q) => q.trim())
                .filter(Boolean)
                .slice(0, 2);
              setGeneratedPromptQuestions(questionsArray);
            }
            ws.close();
          }
        } catch (err) {
          console.error("Error parsing WS data:", err);
        }
      };

      ws.onerror = (err) => {
        console.error("WebSocket error:", err);
        toast.error("WebSocket error occurred. Please try again.");
        setIsLoadingResponse(false);

        if (!finalReceived) {
          setChatHistory((prev) =>
            prev.map((msg) => {
              if (msg.id === botMsgId && !msg.final) {
                return {
                  ...msg,
                  text:
                    "I'm sorry, I'm having trouble contacting the server right now. Please try again later.",
                  final: true,
                };
              }
              return msg;
            })
          );
        }
      };

      ws.onclose = () => {
        setIsLoadingResponse(false);

        if (!finalReceived) {
          setChatHistory((prev) =>
            prev.map((msg) => {
              if (msg.id === botMsgId && !msg.final) {
                return {
                  ...msg,
                  text:
                    "",
                  final: true,
                };
              }
              return msg;
            })
          );
        }
      };
    } catch (error) {
      console.error("WebSocket init error:", error);
      toast.error("Failed to connect to WebSocket. Please try again.");
      setIsLoadingResponse(false);

      // Fallback message if WebSocket fails
      setChatHistory((prev) =>
        prev.map((msg) => {
          if (msg.id === botMsgId && !msg.final) {
            return {
              ...msg,
              text:
                "I'm sorry, I'm having trouble connecting at the moment. Please try again later.",
              final: true,
            };
          }
          return msg;
        })
      );
    }
  };



  // =============== NORMAL CHAT (WS) ===============
  const handleUserQuery = async (userQuery) => {
    const generateUniqueId = () =>
      `${Date.now()}-${Math.floor(Math.random() * 10000)}`;

    let finalReceived = false;

    // 1) User message
    const userMsgId = generateUniqueId();
    const userMessage = {
      id: userMsgId,
      sender: "user",
      text: userQuery,
      final: true,
    };

    // 2) Bot placeholder
    const botMsgId = generateUniqueId();
    const botPlaceholder = {
      id: botMsgId,
      sender: "bot",
      text: "",
      final: false,
    };
    setChatHistory((prev) => [...prev, userMessage, botPlaceholder]);

    setIsLoadingResponse(true);
    setGeneratedPromptQuestions([]);
    setAutoScrollEnabled(true);

    try {
      const documentKeys = Array.isArray(selectedDoc)
  ? selectedDoc.map(doc => doc?.key || doc?.id).filter(Boolean)
  : selectedDoc?.key || selectedDoc?.id
    ? [selectedDoc.key || selectedDoc.id]
    : [];

let token = await getFreshAccessToken();
const wsUrl = documentKeys.length > 0
  ? `wss://stagingbackend.docusensa.com/ws/prompt-library-answer/${chatId}/?token=${token}`
  : `wss://stagingbackend.docusensa.com/ws/qdrant-copilot-chat/${chatId}/?token=${token}`;

const ws = new WebSocket(wsUrl);
activeWsRef.current = ws;
ws.onopen = () => {
  const payload = documentKeys.length > 0
    ? {
        prompt: userQuery,
        document_keys: documentKeys
      }
    : {
        client_message: userQuery,
        chat_id: chatId,
      };

  ws.send(JSON.stringify(payload));
};

      

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          // Progress chunks: append to the bot placeholder
          if (data.type === "progress" && data.message) {
            setChatHistory((prev) =>
              prev.map((msg) =>
                msg.id === botMsgId && !msg.final
                  ? { ...msg, text: msg.text + data.message }
                  : msg
              )
            );
          }

          // Final chunk: mark final
          if (data.type === "final") {
            finalReceived = true;
            const finalChunk = data.message || "";
              const backendMessageId = data?.data?.bot_message_id;

            setChatHistory((prev) =>
              prev.map((msg) =>
                msg.id === botMsgId && !msg.final
                  ? { ...msg, text: msg.text + finalChunk, final: true,id: backendMessageId || msg.id, }
                  : msg
              )
            );

            setIsLoadingResponse(false);
            if (data.data && data.data.run_id) {
              const runId = data.data.run_id;
              setFeedbackId(runId);
            
            }


            // If we have generated questions
            if (data.data && data.data.generated_questions) {
              const questionsArray = data.data.generated_questions
                .split(";")
                .map((q) => q.trim())
                .filter(Boolean)
                .slice(0, 2);
              setGeneratedPromptQuestions(questionsArray);
            }
            ws.close();
          }
        } catch (err) {
          console.error("Error parsing WS data:", err);
        }
      };

      ws.onerror = (err) => {
        console.error("WebSocket error:", err);
        toast.error("WebSocket error occurred. Please try again.");
        setIsLoadingResponse(false);

        if (!finalReceived) {
          setChatHistory((prev) =>
            prev.map((msg) =>
              msg.id === botMsgId && !msg.final
                ? {
                  ...msg,
                  text:
                    "I'm sorry, I'm having trouble contacting the server right now. Please try again later.",
                  final: true,
                }
                : msg
            )
          );
        }
      };

      ws.onclose = () => {
        setIsLoadingResponse(false);

        if (!finalReceived) {
          setChatHistory((prev) =>
            prev.map((msg) =>
              msg.id === botMsgId && !msg.final
                ? {
                  ...msg,
                  text:
                    "",
                  final: true,
                }
                : msg
            )
          );
        }
      };
    } catch (error) {
      console.error("WebSocket init error:", error);
      toast.error("Failed to connect to WebSocket. Please try again.");
      setIsLoadingResponse(false);

      setChatHistory((prev) =>
        prev.map((msg) =>
          msg.id === botMsgId && !msg.final
            ? {
              ...msg,
              text:
                "I'm sorry, I'm having trouble connecting at the moment. Please try again later.",
              final: true,
            }
            : msg
        )
      );
    }
  };




  const handleSend = () => {
    if (!PromptChatInput.trim()) {
      toast.error("Please enter a prompt!");
      return;
    }
      setHasSentMessage(true); 
const enrichedMessage = selectedDoc
  ? `${PromptChatInput.trim()} : ${selectedDoc.type.charAt(0).toUpperCase() + selectedDoc.type.slice(1)} : ${selectedDoc.name.replace(/\.pdf$/i, "")}`
  : PromptChatInput.trim();


handleUserQuery(enrichedMessage);

// Clear input
setPromptChatInput("");
    setClientMessage("");
    setSelectedDoc(null);
    setTypedDummyMessages([]); 
    
    
    if (textareaRef.current) {
    textareaRef.current.style.height = "auto";
  }// Clear recommended messages
  };

const formatText = useCallback((input) => {
    if (typeof input !== "string") return "";

  let formattedText = input
    .trimStart()
    .replace(/^### Table.*\n?/gm, "") // remove markdown table title
.replace(/^### (.*$)/gm, '<div style="font-size: 16px; font-weight: 600; margin: 12px 0 6px; color: #000;">$1</div>')

    .replace(/\n{2,}(?=\|.+\|[\r\n]+\|[-\s|:]+\|)/g, "") 

  // Step 2: Parse markdown tables
  const tableRegex = /\|(.+?)\|[\r\n]+\|([-\s|:]+)\|[\r\n]+((\|.*?\|[\r\n]+)+)/g;
  formattedText = formattedText.replace(tableRegex, (match, header, separator, body) => {
    const headers = header.split("|").map(h =>
      `<th style="padding: 8px; text-align: left; border: 1px solid rgb(201, 94, 190); background-color: rgb(250, 235, 247); font-size: 15px; font-weight: 600; color: rgb(201, 94, 190);">${h.trim()}</th>`
    ).join("");

    const rows = body.trim().split("\n").map(row => {
      const cells = row.split("|").slice(1, -1).map(cell =>
        `<td style="padding: 8px; border: 1px solid rgba(201, 94, 190, 0.3); font-size: 14px; font-weight: 400; color: #444;">${cell.trim().replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")}</td>`
      ).join("");
      return `<tr>${cells}</tr>`;
    }).join("");

    return `
      <div style="overflow-x: auto; margin-top: 2px; margin-bottom: 8px;">
<table style="border-collapse: collapse; width: 100%; font-size: 14px; border: 1px solid rgb(201, 94, 190);">
          <thead><tr style="background-color: #f5f5f5;">${headers}</tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
  });

  // Step 3: Apply formatting rules
  formattedText = formattedText.replace(/(^|\n)\s*\*\s+/g, "$1• "); // bullets
  formattedText = formattedText.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>"); // bold
  formattedText = formattedText.replace(/^([^:\n]+):\s*(.+)$/gm, "<b>$1:</b> $2"); // label:value
  formattedText = formattedText.replace(/(?<!<\/table>)\n(?!<table)/g, "<br/>"); // convert line breaks (ignore tables)

  // Step 4: Wrap final result
  return `<div style="white-space: pre-wrap; word-wrap: break-word; line-height: 1.5;">${formattedText}</div>`;
}, []);

  // =============== VIEW DETAILS / CHAT WITH DOC ===============
  // const handleViewDetails = (documentKey, documentType) => {
  //   if (!documentKey || !SummarizeDocKey) {
  //     toast.error("File key is not available.");
  //     return;
  //   }
  //   if (documentType === "contract") {
  //     navigate("/Contract/contract-details", {
  //       state: { contractKey: documentKey },
  //     });
  //   } else if (documentType === "invoice") {
  //     navigate("/Invoices/Invoice_Details", {
  //       state: { invoiceKey: documentKey },
  //     });
  //   } else {
  //     console.warn("Unsupported document type:", documentType);
  //   }
  // };

  // const handleChatWithDoc = () => {
  //   if (!documentKey || !documentUrl) {
  //     toast.error("Document information is missing. Please try again.");
  //     return;
  //   }
  //   if (documentType === "contract") {
  //     // Ensure that contractKey is defined and correct
  //     navigate(`/Contract/contractChat?ckey=${documentKey}`);
  //   } else if (documentType === "invoice") {
  //     navigate(
  //       `/Invoices/Invoice_chat?invoiceKey=${documentKey}&invoiceUrl=${encodeURIComponent(
  //         documentUrl
  //       )}`
  //     );
  //   } else {
  //     navigate("/chat", { state: { pdfUrl: documentUrl, pdfKey: documentKey } });
  //   }
  // };


  const handleViewDetails = (documentKey, documentType) => {
    // Use documentKey and documentType if available; otherwise fallback to summarization values
    const keyToUse = documentKey || SummarizeDocKey;
    const typeToUse = documentType || SummarizeDocType;

    if (!keyToUse) {
      toast.error("File key is not available.");
      return;
    }
 if (typeToUse === "contract") {
    // Updated URL format to include key directly
    navigate(`/Contract/contract-details/${keyToUse}`, {
      state: { contractKey: keyToUse },
    });
  } else if (typeToUse === "invoice") {
    // Unified to match contract pattern
    navigate(`/Invoices/Invoice_Details/${keyToUse}`, {
      state: { invoiceKey: keyToUse },
    });

    } else {
      console.warn("Unsupported document type:", typeToUse);
    }
  };

const handleChatWithDoc = () => {
  const keyToUse = documentKey || SummarizeDocKey;
  const urlToUse = documentUrl || SummarizeDocUrl;
  const typeToUse = documentType || SummarizeDocType;
  const idToUse = selectedDoc?.id || SummarizeDocKey || documentId || null;


  if (!keyToUse || !urlToUse || !idToUse) {
    toast.error("Document information is missing.");
    return;
  }

  if (typeToUse === "contract") {
    navigate(`/Contract/contractChat?ckey=${keyToUse}&cid=${idToUse}`);
  } else if (typeToUse === "invoice") {
    navigate(
      `/Invoices/Invoice_chat?invoiceKey=${keyToUse}&invoiceUrl=${encodeURIComponent(urlToUse)}&cid=${idToUse}`
    );
  } else {
    navigate("/chat", {
      state: {
        pdfUrl: urlToUse,
        pdfKey: keyToUse,
        pdfId: idToUse,
      },
    });
  }
};




  // =============== THUMBS UP/DOWN & FEEDBACK ===============
const handleThumbsUpClick = (messageId) => {
  const message = chatHistory.find((msg) => msg.id === messageId || msg.bot_message_id === messageId);

  const runId = message?.run_id;
  const botMessageId = message?.bot_message_id || message?.id;

  if (!runId || !botMessageId) {
    console.warn("Missing run_id or bot_message_id for message", message);
    return;
  }

  setThumbsUpClicked((prev) => ({ ...prev, [botMessageId]: true }));
  setThumbsDownClicked((prev) => ({ ...prev, [botMessageId]: false }));

  submitFeedback(botMessageId, runId, "up");
};




const handleThumbsDownClick = (messageId) => {
  const message = chatHistory.find(
    (msg) => msg.id === messageId || msg.bot_message_id === messageId
  );

  const runId = message?.run_id;
  const botMessageId = message?.bot_message_id || message?.id;

  if (!botMessageId || !runId) {
    console.warn("⚠️ Missing botMessageId or runId for thumbs down:", message);
    return;
  }

  const newThumbsDownValue = !thumbsDownClicked[botMessageId];

  setThumbsDownClicked((prev) => ({
    ...prev,
    [botMessageId]: newThumbsDownValue,
  }));
  setThumbsUpClicked((prev) => ({
    ...prev,
    [botMessageId]: false,
  }));

  if (newThumbsDownValue) {
    setMessageIdToFeedback(botMessageId);  // ✅ use botMessageId here
    setFeedbackId(runId);                  // ✅ store run_id explicitly
    setSelectedFeedbackType("down");
    setShowThumbsDownPopup(true);
  }
};


const submitFeedback = async (messageId, runId, feedbackType) => {
  if (!messageId || !runId || !feedbackType) {
    console.error("Missing data for feedback submission.", messageId, runId, feedbackType);
    return;
  }

  const token = await getFreshAccessToken();

  const payload = {
    message_id: messageId,
    run_id: runId,
    feedback_type: feedbackType,
  };

  try {
    const response = await api.post(`api/v1/contract/feedback/`, payload);
  } catch (error) {
    console.error("Feedback submission error:", error);
  }
};





  const handleCopy = (messageId, text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedMessageId(messageId);
        setTimeout(() => setCopiedMessageId(null), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy message:", err);
      });
  };

  


  const handleSubmitThumbsDownFeedback = async () => {
    const selectedFeedback = [];
    if (selectedCheckboxes.factuallyIncorrect) {
      selectedFeedback.push("Not factually correct.");
    }
    if (selectedCheckboxes.refused) {
      selectedFeedback.push("Refused when it shouldn’t have.");
    }
    if (selectedCheckboxes.notFollowingInstructions) {
      selectedFeedback.push("Not Following Instructions.");
    }
    const combinedFeedback = [...selectedFeedback, feedbackMessage].join("\n");
    setFeedbackMessage(combinedFeedback);

    // Pass the proper parameters to submitFeedback:
    try {
      await submitFeedback(messageIdToFeedback, feedbackId, selectedFeedbackType);
      setSelectedCheckboxes({
        factuallyIncorrect: false,
        refused: false,
        notFollowingInstructions: false,
      });
      setFeedbackMessage("");
      setShowThumbsDownPopup(false);
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };


  const handleClosePopup = () => {
    setShowThumbsDownPopup(false);
    setSelectedCheckboxes({
      factuallyIncorrect: false,
      refused: false,
      notFollowingInstructions: false,
    });
    setFeedbackMessage("");
  };

  // =============== CHAT HISTORY SIDEBAR (OPTIONAL) ===============
  const [isOpen, setIsOpen] = useState(false);
 const toggleChatHistory = () => {
  setIsOpen((prev) => {
    return !prev;
  });
};





  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = (messageId) => {
    setOpenDropdownId((prev) => (prev === messageId ? null : messageId));
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenDropdownId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getContextualHint = (type) => {
    switch (type.toLowerCase()) {
      case "invoice":
        return "Ask about due dates, amounts, or line items...";
      case "contract":
        return "Ask about key terms, parties, or expiry clauses...";
      case "spreadsheet":
        return "Ask about summary, trends, or specific columns...";
      case "document":
        return "Ask for summary, insights, or specific sections...";
      default:
        return "Type your question...";
    }
  };
  

  // =============== RENDER ===============
  return (
    <div className="AI-CP-PL-full-container">
<div
  key={isOpen ? "open" : "closed"} // forces React to re-render the div
  className="AI-CP-PL-docChatContainer transition-transform duration-300"
  style={{
    transform: isChatHistoryOpen ? 'translateX(13rem)' : 'translateX(0)',
  }}
>


        {/* Left Section: Chat History (optional) 
        <div
          className="AI-CP-CopilotChatHistoryContainer flex gap-4"
          style={{
            left: isMenuOpen ? "280px" : "150px",
            position: "absolute",
            top: "86px",
          }}
        >
          {/* onNewChat triggers a brand new chat - clear local storage if you want */}
        {/* <div className="relative group">
            <button
              className="w-[44px] h-[36px] rounded-[6px] border border-[rgba(0,0,0,0.1)] bg-white p-[8px_12px] shadow flex items-center justify-center"
              onClick={() => {
                // Clear local storage so we start fresh
                localStorage.removeItem("promptChat_history");
                localStorage.removeItem("promptChat_questions");
                localStorage.removeItem("promptChat_clientMessage");
                localStorage.removeItem("promptChat_finalResponse");
                localStorage.removeItem("promptChat_chatId");

                setChatHistory([]);
                setGeneratedPromptQuestions([]);
                setClientMessage("");
                setChatResponse("");
                setLocalChatId(null);

                // Then call parent’s onNewChat logic
                if (onNewChat) onNewChat();
              }}
            >
              <img src="/newChat-icon.svg" alt="New Chat Icon" className="w-4 h-4" />
            </button>

            {/* Tooltip Below */}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-3 py-1 bg-black text-white text-xs rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
          Start New Chat
          {/* Upward Arrow */}
          <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-black rotate-45"></div>
        </div>
        {/* </div>  */}
        {/* Render ChatHistory and pass the callback */}
        {/* <ChatHistory
            isOpen={isOpen}
            chatHistory={chatHistory}
            setChatHistory={setChatHistory}
            onSelectChat={handleSelectChat}
          /> */}


        {/* <button className="chat-historyBtn" onClick={toggleChatHistory}>
            <span>Chat History</span>
            <img src={arrowForward2} alt="Forward arrow" />
          </button> */}

        {/* </div> */}

        {/* Main Chat Content */}
        <div className="AI-CP-PL-docChatContent">
          <div className="AI-CP-PL-message-container" ref={chatContainerRef} style={{
  width: isChatHistoryOpen ? 'calc(100% - 7rem)' : '100%',
  transition: 'width 0.3s ease',
}}
>
            {chatHistory.map((message, index) => {
              const isBot = message.sender === "bot";
              const isFinal = message.final;
              const isFirstBotMessage =
                isBot && chatHistory.findIndex((msg) => msg.sender === "bot") === index;

              return (
                <div
                  key={`${message.id}-${index}`}
                  className={`mb-2 ${isBot
                    ? "Ai-CP-bot-message-container w-full flex items-start"
                    : "w-full flex justify-end"
                    }`}
                >
                  {/* BOT ICON
                  {isBot && (
                    <div className="PL-bot-icon-container flex-shrink-0 mr-2">
                      <img
                        src="/bot-icon.svg"
                        alt="Bot Icon"
                        className={` ${isFirstBotMessage && isLoadingResponse ? "PL-bot-icon-first h-6 w-6 rounded-full" : "PL-bot-icon h-6 w-6 rounded-full"}`}
                      />
                    </div>
                  )} */}

                  {/* MESSAGE BUBBLE */}
                  <div className="flex flex-col">
                    <div className="user-interactions flex mr-4">
  {message.sender === "user" ? (
    <div className="flex flex-col items-end max-w-full">
      {/* If message is in enriched format: "prompt : Type : Filename" */}
      {(message.text.includes(" : ") && message.text.split(" : ").length === 3) && (
        <div className="flex items-center bg-[#FEF9F7] border border-gray-500
 text-white rounded-lg px-2 py-1 mb-2 w-fit"
          style={{ fontFamily: "Outfit, sans-serif", fontSize: "14px", fontWeight: 500, gap: "10px" }}>
{(() => {
  const parts = message.text.split(" : ");
  const filename = parts[2] || "";
  const extension = filename.split(".").pop().toLowerCase();

   if (["jpeg", "jpg", "png"].includes(extension)) {
    return (
     <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="#374151" strokeWidth={1.5}>
  <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3h10.5a2.25 2.25 0 012.25 2.25v13.5A2.25 2.25 0 0117.25 21H6.75A2.25 2.25 0 014.5 18.75V5.25A2.25 2.25 0 016.75 3z" />
  <path strokeLinecap="round" strokeLinejoin="round" d="M9 13.5l1.5-2 2.25 3L15 12l3 4.5" />
</svg>

    );
  }

  const iconSrc =
    extension === "pdf"
      ? "/pdff.svg"
      : extension === "xlsx"
      ? "/Xls.svg"
      : extension === "xls"
      ? "/Xls.svg"
      : extension === "csv"
      ? "/CSV.svg"
      : extension === "txt"
      ? "/TXT.svg"
      : extension === "docx"
      ? "/docX.svg"
      : "/pdff.svg"; // fallback

  return (
    <img src={iconSrc} alt="doc" className="w-6 h-6" />
  );
})()}
          <div className="flex flex-col leading-tight">
          <span className="text-sm font-normal text-gray-500 truncate max-w-[320px]">
  {message.text.split(" : ")[2]}
</span>
<span className="text-xs font-semibold text-black capitalize">
  {message.text.split(" : ")[1]}
</span>



          </div>
        </div>
      )}

      {/* Actual user prompt */}
      <span className="user-message-style text-right">
        {(message.text.includes(" : ") && message.text.split(" : ").length === 3)
          ? message.text.split(" : ")[0]
          : message.text}
      </span>
    </div>
  ) : (
    <>
      {/* Show Thinking Indicator while bot is responding */}
      {message.final === false && message.text === "" ? (
        <div className="min-w-[300px] max-w-full p-4">
          <ThinkingIndicator isThinking={isLoadingResponse} />
        </div>
      ) : (
        <>
          {/* Show BOT ICON only when thinking is complete */}
          {isBot && (
            <div className="PL-bot-icon-container flex-shrink-0 mr-2">
              <img
                src="/dclogo.svg"
                alt="Bot Icon"
                className="PL-bot-icon h-6 w-6 rounded-full"
              />
            </div>
          )}
          {/* Display the bot message */}
          <span
            className="AI-CP-PL-bot-message-content"
            dangerouslySetInnerHTML={{ __html: formatText(message.text) }}
          />
        </>
      )}
    </>
  )}
</div>


                    <div className="user-interaction-buttons">
                      {/* Reaction Buttons if it's a final bot message */}
                      {isBot && ((index !== chatHistory.length - 1) || (!isLoadingResponse)) && (
                        <div className="AI-CP-PL-reactionContainer">
                          <div className="Ai-CP-reactions flex gap-2 text-gray-500 mt-2">
                            {((documentKey || SummarizeDocKey) && !isFirstBotMessage) && (
                              <span
                                className="see-more-reaction-icon cursor-pointer"
                                ref={dropdownRef}
                              >
                                <img
                                  src="/more-icon.svg"
                                  alt="more icon"
                                  onClick={() => toggleDropdown(message.id)}
                                />
                                {openDropdownId === message.id && (
                                  <div className="dropdown-menu">
                                    {(documentType || SummarizeDocType) !== "normal_document" && (
                                      <button
                                        onClick={() => handleViewDetails(documentKey, documentType)}
                                      >
                                        <img src="/eye-icon.svg" alt="eye icon" />
                                        <span>View More</span>
                                      </button>
                                    )}
                                    <button onClick={handleChatWithDoc}>
                                      <img src="chatButton-icon.svg" alt="chat-button" />
                                      <span>Chat</span>
                                    </button>
                                  </div>
                                )}
                              </span>
                            )}

                            <span
                              className="reaction-icon cursor-pointer"
                              onClick={() => handleThumbsUpClick(message.id)}
                            >
                              <img
                                src={
                                  thumbsUpClicked[message.id]
                                    ? "/thums-up-filled.svg"
                                    : "/thums-up.svg"
                                }
                                alt="Thumbs Up"
                              />
                            </span>
                            <span
                              className="reaction-icon cursor-pointer"
                              onClick={() => handleThumbsDownClick(message.id)}
                            >
                              <img
                                src={
                                  thumbsDownClicked[message.id]
                                    ? "/thums-down-filled.svg"
                                    : "/thums-down.svg"
                                }
                                alt="Thumbs Down"
                              />
                            </span>
                            <span
                              className="reaction-icon cursor-pointer"
                              onClick={() => handleCopy(message.id, message.text)}
                            >
                              <img
                                src={
                                  copiedMessageId === message.id ? "/copy-clicked.svg" : "/copy.svg"
                                }
                                alt="Copy"
                              />
                            </span>
                          </div>

                          {((documentKey || SummarizeDocKey) && isFirstBotMessage) && (
                            <div className="AI-CP-reaction-buttons mt-2">
                              {(documentType || SummarizeDocType) !== "normal_document" && (
                                <button
                                  className="w-[120px] h-[34px] rounded-[6px] border border-black/10 bg-[#e9e9eb] px-[20px] py-[6px]"
                                  onClick={() => handleViewDetails(documentKey, documentType)}
                                >
                                  View More
                                </button>
                              )}
                              <button
                                className="w-[99px] h-[34px] rounded-[6px] border border-black/10 bg-[#e9e9eb] px-[35px] py-[6px]"
                                onClick={handleChatWithDoc}
                              >
                                Chat
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              );
            })}

            {/* Error if any */}
            {error && (
              <div className="AI-CP-bot-message-container w-full flex items-start mb-4">
                <div className="AI-CP-bot-message-content text-red-600 text-sm rounded-lg p-4 max-w-[85%]">
                  <strong>Error:</strong> {error}
                </div>
              </div>
            )}
          </div>

          <div className="dummyContent">
            {/* Recommended Questions */}
            <div className="AI-CP-PL-dummy-container">
              {generatedPromptQuestions?.map((question, idx) => (
                <div
                  key={idx}
                  className={`AI-CP-PL-dummy-message-box border rounded-lg  cursor-pointer ${clickedIndex === idx ? "opacity-50" : "opacity-100"
                    }`}
                  onClick={() => {
                    setPromptChatInput(question.trim());

                    setClickedIndex(idx);
                  }}
                >
                  <span className="icon mr-2">
                    <img src="/dummy-prompt-icon.svg" alt="Prompt Icon" />
                  </span>
                  <p className="text-sm">{question.trim() || "..."}</p>
                </div>
              ))}
            </div>

            {/* Input Area */}
            <div className="input-container-holders">
              
  
  {selectedDoc && (
<div
  className="ml-2 mt-1 flex items-center bg-gray-100 rounded-full px-3 py-2 text-gray-800 max-w-full whitespace-nowrap overflow-hidden"
  title={selectedDoc.name} // ✅ Move it here
>
  <span className="font-medium text-purple-600 mr-1 flex-shrink-0">
    {selectedDoc.type} :
  </span>
  <span className="font-medium text-ellipsis overflow-hidden whitespace-nowrap max-w-[200px]">
    {selectedDoc.name.split(" ").slice(0, 25).join(" ") + (selectedDoc.name.split(" ").length > 25 ? "..." : "")}
  </span>
  <button
    className="ml-2 text-gray-500 font-bold focus:outline-none flex-shrink-0"
    onClick={() => {
      setSelectedDoc(null);
      setPromptChatInput("");
    }}
  >
    ×
  </button>
</div>

)}



              <textarea
               placeholder={
                isLoadingResponse
                  ? "Copilot is responding..."
                  : selectedDoc
                    ? `${getContextualHint(selectedDoc.type)}`
                    : "How can I help? Type your question or choose a prompt"
              }
              
              
              
                
                className="input-field-holder w-[87%] min-h-[22px] resize-none text-[#3f3f46] font-outfit text-lg font-semibold leading-6 ml-[35px] mt-[17px] border-0 outline-none bg-transparent overflow-hidden max-h-[88px] overflow-y-auto"
                style={{
                  paddingTop: "6px", // Adjust padding to reduce top space
                  marginTop: "5px",
                  lineHeight: "20px", // Use negative margin to bring text closer
                }}
  value={PromptChatInput}


                onChange={(e) => {
  handlePromptChatChange(e); // call your existing logic
  setClientMessage(e.target.value); // also update client message
  if (textareaRef.current) {
    textareaRef.current.style.height = "auto"; // reset
    textareaRef.current.style.height = `${Math.min(
      textareaRef.current.scrollHeight,
      88
    )}px`; // auto-resize up to 88px
  }
}}

                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    if (!isLoadingResponse && PromptChatInput.trim()) {
                      handleSend();
                    }
                  }
                }}
                ref={textareaRef}
              />
              {showObjects && (
                <div className="CP-AI-dropdown-wrapper">
                  <div className="CP-AI-dropdown-container">
                    {/* Your dropdown content */}
                    <h1 className="CP-AI-dropdown-heading">Document Types</h1>
                    <ul className="CP-AI-dropdown-menu CP-AI-dropdown-objects">
                      {["Documents", "Contracts", "Invoices", "Spreadsheets"].map((obj) => (
                        <li
                          key={obj}
                          className="CP-AI-dropdown-item"
                          onClick={() => handleObjectSelection(obj)}
                        >
                          {objectIcons[obj] && (
                            <span className="CP-AI-dropdown-icon">{objectIcons[obj]}</span>
                          )}
                          <span className="CP-AI-dropdown-text">{obj}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {showValues && selectedObject && (
                <div className="CP-dropdown-wrapper-values" ref={dropdownValuesRef}>
                  <div className="CP-dropdown-container-values">
                    <h1 className="CP-dropdown-heading-values">
                      Select {getSingular(selectedObject)}
                    </h1>
                    <div className="CP-AI-values-SearchBox">
                      <img src="/search.svg" alt="search icon" />
                      
                      <input
                        type="text"
                        placeholder="Search here"
                        className="CP-AI-values-SearchBox-input"
                        onChange={handleValuesSearch}
                      />
                    </div>
                    {/* New scrollable container wrapping the list */}
                    <div className="CP-dropdown-scrollable">
                      <ul className="CP-dropdown-menu-values">
                        {filteredValues.length > 0 ? (
                          filteredValues.map((val, index) => (
                            <li
                              key={val.id || index} // Ensure unique key
                              className="CP-dropdown-item-values"
                              onClick={() => handleValueSelection(val)}
                              title={val.name}
                            >
                              <img src="/ai-object-document-icon.svg" alt="documents icon" />
                              <span>{val.name}</span>
                            </li>
                          ))
                        ) : (
                          <li className="CP-dropdown-item-values no-data">
                            No values found
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {showAtDropdown && (
                <div className="CP-dropdown-wrapper-at">
                  <div className="CP-dropdown-container-at">
                    <h1 className="CP-dropdown-heading-at">Select Document</h1>
                    <div className="CP-dropdown-searchbox-at">
                      <img
                        src="/search.svg"
                        alt="search icon"
                        className="CP-dropdown-search-icon-at"
                      />
                      <input
                        type="text"
                        placeholder="Search here"
                        className="CP-dropdown-search-input-at"
                        onChange={handleAtSearch}
                      />
                    </div>
                    {/* New scrollable container */}
                    <div className="CP-dropdown-scrollable-at">
                      <ul className="CP-dropdown-menu-at">
                        {filteredAtOptions.length > 0 ? (
                          filteredAtOptions.map((doc) => (
                            <li
                              key={doc.id}
                              className="CP-dropdown-item-at"
                              onClick={() => handleAtSelection(doc)}
                              title={doc.display}
                            >
                              <img
                                src="/ai-object-document-icon.svg"
                                alt="document icon"
                                className="CP-dropdown-item-icon-at"
                              />
                              <span>{doc.display}</span>
                            </li>
                          ))
                        ) : (
                          <li className="CP-dropdown-item-at no-data">No documents found</li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              <button
                className="AI-CP-PL-send-button-holder"
             
              >
               <img
  src={isLoadingResponse ? "/loading-send-button2.svg" : "/send-copilot.svg"}
  alt={isLoadingResponse ? "Stop" : "Send"}
  onClick={() => {
    if (isLoadingResponse) {
      handleStopStreaming(); // Stop streaming if response is ongoing
    } else if (PromptChatInput.trim()) {
      handleSend(); // Otherwise, send the message
    }
  }}
  className={isLoadingResponse ? "PL-send-icon-stop" : "PL-send-icon"}
  style={{ width: "44px", height: "44px", cursor: "pointer" }}
/>

              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Thumbs Down Popup */}
      {showThumbsDownPopup && (
        <div className="popup-container-thumsdown">
          <div className="popup-content-thumsdown">
            <div>
              <div>
                <button className="close-button-thumsdown" onClick={handleClosePopup}>
                  <p>x</p>
                </button>
              </div>
              <div className="paragraph-container">
                <p className="paragraph-container-para1">What went Wrong?</p>
                <p className="paragraph-container-para2">
                  Select feedback that reflects how well this response addressed your question or concern.
                </p>
                <div className="checkbox-container-thumsup">
                  <label className="thumsup-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedCheckboxes.factuallyIncorrect}
                      onChange={(e) =>
                        setSelectedCheckboxes((prev) => ({
                          ...prev,
                          factuallyIncorrect: e.target.checked,
                        }))
                      }
                    />
                    Not factually correct.
                  </label>
                  <label className="thumsup-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedCheckboxes.refused}
                      onChange={(e) =>
                        setSelectedCheckboxes((prev) => ({
                          ...prev,
                          refused: e.target.checked,
                        }))
                      }
                    />
                    Refused when it shouldn’t have.
                  </label>
                  <label className="thumsup-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedCheckboxes.notFollowingInstructions}
                      onChange={(e) =>
                        setSelectedCheckboxes((prev) => ({
                          ...prev,
                          notFollowingInstructions: e.target.checked,
                        }))
                      }
                    />
                    Not Following Instructions.
                  </label>
                </div>
                <div className="line-with-text">
                  <span>Or</span>
                </div>
                <div className="rectangular-box">
                  <div className="feedback-container">
                    <textarea
                      className="feedback-input resize-none border-none focus:outline-none focus:ring-0"
                      maxLength="250"
                      placeholder="Your feedback is much appreciated and helps improve the AI!"
                      value={feedbackMessage}
                      onChange={(e) => setFeedbackMessage(e.target.value)}
                    />
                  </div>
                  <p className="character-count">Maximum: 250 characters</p>
                </div>
                <button
                  className={`custom-button-thumsdown ${!feedbackMessage.trim() &&
                    !Object.values(selectedCheckboxes).some((x) => x)
                    ? "disabled-button-thumsdown"
                    : "enabled-button-thumsdown"
                    }`}
                  onClick={handleSubmitThumbsDownFeedback}
                  disabled={
                    !feedbackMessage.trim() &&
                    !Object.values(selectedCheckboxes).some((x) => x)
                  }
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PromptChat;